import React from 'react';
import Select, { components } from "react-select";

const { Option, MultiValue } = components;

export const mapResourceTypeToIcon = (type) => {
  switch (type) {
    case 'User':
      return 'user';
    case 'Group':
      return 'home';
    default:
      return 'question';
  }
}

const ShareWithOption = (props) => {
  return <Option styles={{zIndex: 3}} {...props}>
    <i className={`fas fa-${mapResourceTypeToIcon(props.data.recipient_type)} mr-2`}/>
    {props.data.label}
  </Option>
}

const ShareWithMultiOption = (props) => {
  return <MultiValue {...props}>
    <i className={`fas fa-${mapResourceTypeToIcon(props.data.recipient_type)} mr-2`}/>
    {props.data.label}
  </MultiValue>
}
export const parseUserName = (user) => {
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  }
  if (user.first_name) {
    return user.first_name;
  }
  if (user.last_name) {
    return user.last_name;
  }

  return '[No Name]';
};

const NoteShareWith = ({userTags, groupTags, onChange, values}) => {
  const mappedValues = (values || []).map((value) => {
    if (value && Object.prototype.hasOwnProperty.call(value, 'label')) {
      return value;
    }

    const isGroup = value && value.recipient_type === 'Group';
    const id = (value && (value.value ?? value.id ?? value.recipient_id));
    const label = (value && (value.label ?? (isGroup ? value.name : parseUserName(value))));
    const recipient_type = value && value.recipient_type ? value.recipient_type : (isGroup ? 'Group' : 'User');

    return { value: id, label, recipient_type };
  });

  const userOptions = (userTags || []).map((user) => {
    return {
      value: user.id ? user.id : user.recipient_id,
      label: parseUserName(user),
      recipient_type: 'User'
    };
  });
  
  const groupOptions = (groupTags || []).map((group) => {
    return {
      value: group.id ? group.id : group.recipient_id,
      label: group.name || group.label,
      recipient_type: 'Group'
    };
  });

  return (
    <Select
      placeholder={<div>Select Staff or Facility</div>}
      isMulti
      value={mappedValues}
      onChange={(updatedSelected) => onChange(updatedSelected)}
      components={{ Option: ShareWithOption, MultiValue: ShareWithMultiOption }}
      options={[{
        label: 'Groups',
        options: groupOptions
      }, {
        label: 'Users',
        options: userOptions
      }]}
      menuPortalTarget={document.body}
      menuPosition={'fixed'}
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
    />
  );
}

export default NoteShareWith;
